<div class="global-nav--container">
    <nav mat-nav-bar class="global-nav">
        <a routerLink="/">
            <tapestry-pi-logo class="pi-logo"></tapestry-pi-logo>
        </a>
        @if (!layout.isMobile) {
            <tapestry-nav-menu-list
                class="nav-list"
                [modules]="navigationModules"
            ></tapestry-nav-menu-list>
        }
        <div class="section-right">
            <account-selector></account-selector>
            @if (enablePIAssistant()) {
                <button
                    tap-button
                    variant="secondary"
                    size="sm"
                    class="pi-assistant-button"
                    (click)="openPIAssistant()"
                    piTesting="pi-assistant-button"
                >
                    <tap-icon name="ai_bold" size="sm"></tap-icon>
                    <span>
                        {{
                            'client-admin.organization-settings.ai-settings.ai-assistant.title'
                                | translate
                        }}
                    </span>
                </button>
            }
            @if (!hidePricingPackaging && !layout.isTabletOrBelow) {
                <upgrade-account
                    (onUpgradeAccountClick)="triggerUpgradeAccountClick()"
                    [showUpgradeButtonIcon]="true"
                    buttonTextKeyName="'upgradeButton.plans.pricing.text'"
                ></upgrade-account>
            }
        </div>
        @if (!layout.isTabletOrBelow) {
            <div class="icon-container">
                @if (isDevMenuEnabled) {
                    <developer-dropdown></developer-dropdown>
                }
                @if (isInternalOIEnabled && !disableAll) {
                    <tapestry-icon-button
                        iconName="pattern"
                        trackingName="sellerToolsIcon"
                        [altText]="
                            'client-core.global-nav.partner-support.title'
                                | translate
                        "
                        (iconClicked)="openOIPeek()"
                    ></tapestry-icon-button>
                }
                @if (
                    !disableAll &&
                    !moduleAccess.hasOnlyPerform &&
                    !hideGroupAnalytics
                ) {
                    <tapestry-icon-button
                        iconName="graph_analytics"
                        [altText]="'analytics.title' | translate"
                        (iconClicked)="goToGroupAnalytics()"
                    ></tapestry-icon-button>
                }
                @if (!disableAll) {
                    <global-search-menu></global-search-menu>
                }
                @if (!disableAll && !hideGlobalAdmin) {
                    <settings-dropdown
                        (adminClick)="moduleClick.emit()"
                    ></settings-dropdown>
                }
                <div
                    (click)="myProfileOpen = !myProfileOpen"
                    tapestry-rich-text-tooltip
                    #tooltipOrigin="tapestry-rich-text-tooltip"
                    [tooltipContent]="myProfile"
                    [tooltipOnClick]="true"
                >
                    @if (!customAvatarsEnabled) {
                        <tapestry-icon-button
                            iconName="user_bold"
                            [altText]="TR.key('globalnav.myProfile-altText')"
                            [disabled]="false"
                            trackingName="my-profile-tooltip-icon"
                            piTesting="my-profile-tooltip-icon"
                        ></tapestry-icon-button>
                    } @else {
                        <avatar-profile
                            class="special-tooltip-class"
                            trackingName="my-profile-avatar-icon"
                            piTesting="my-profile-avatar-icon"
                            button
                        ></avatar-profile>
                    }
                    <tapestry-rich-text-tooltip-content
                        [open]="myProfileOpen"
                        (backdropClicked)="closeMyProfile()"
                        [tooltipOrigin]="tooltipOrigin"
                        [tooltipPosition]="TooltipPosition.BelowLeft"
                        [tooltipOnClick]="true"
                        #myProfile
                    >
                        <my-profile
                            class="my-profile-overlay-container"
                            (dismissMyProfile)="closeMyProfile()"
                        ></my-profile>
                    </tapestry-rich-text-tooltip-content>
                </div>
                @if (enableLanguageSelection()) {
                    <button
                        class="language-selection-button"
                        (click)="languageSelectionOpen = !languageSelectionOpen"
                        tapestry-rich-text-tooltip
                        #languageSelectionTrigger="tapestry-rich-text-tooltip"
                        [tooltipContent]="languageSelection"
                        [tooltipOnClick]="true"
                    >
                        <tapestry-icon-button
                            iconName="world_bold"
                            trackingName="language-selection-tooltip-icon"
                            piTesting="language-selection-tooltip-icon"
                        ></tapestry-icon-button>
                        <tapestry-rich-text-tooltip-content
                            [open]="languageSelectionOpen"
                            (backdropClicked)="closeLanguageSelection()"
                            [tooltipOrigin]="languageSelectionTrigger"
                            [tooltipPosition]="TooltipPosition.BelowLeft"
                            [tooltipOnClick]="true"
                            #languageSelection
                        >
                            <language-selection-menu
                                class="language-selection-overlay-container"
                                (dismissLanguageSelection)="
                                    closeLanguageSelection()
                                "
                            />
                        </tapestry-rich-text-tooltip-content>
                    </button>
                }
            </div>
        } @else {
            <mobile-nav
                class="mobile-menu--trigger"
                [modules]="
                    layout.isMobile ? globalNavService.availableModules : []
                "
                (showMyProfile)="openMyProfile()"
            ></mobile-nav>
        }
    </nav>
    <global-nav-zazzbar></global-nav-zazzbar>
    <time-trial-banner class="banner--sticky"></time-trial-banner>
</div>
